import { render } from "./AvatarCropModal.vue?vue&type=template&id=55a8753c&scoped=true&ts=true"
import script from "./AvatarCropModal.vue?vue&type=script&lang=ts"
export * from "./AvatarCropModal.vue?vue&type=script&lang=ts"

import "./AvatarCropModal.vue?vue&type=style&index=0&id=55a8753c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a8753c"]])

export default __exports__